import React, {useState} from 'react'
import { Link } from 'react-router-dom'
import { FaOpencart } from 'react-icons/fa';
import { BiUser } from 'react-icons/bi';
import Cart from '../Cart/Cart';

import './navbar.css'

function Navbar({cartTotal, cart, removeFromCart, updateCartQty}) {

    const [openNav, setOpenNav] = useState(false)
    const [openCart, setOpenCart] = useState(false)

    const  toggleClass = (func, elem) => {
        func(!elem)
    }

    return (
        <>  
            <Cart updateCartQty={updateCartQty} removeFromCart={removeFromCart} cart={cart} setOpenCart={setOpenCart} open={openCart ? "open" : ""} />
            <div className="header">
                <div className='container-fluid header-container'>
                    <div className="logo">
                        <Link to='/' >
                            <a href="/" className="nav-link serif">LUSTORE</a>
                        </Link>
                    </div>
                    <ul className={`nav-links transition-width-all ${openNav ? "open" : ""}`}>
                        <button onClick={() => setOpenNav(false)} className="btn serif link-close on-mobile nav-link">-Close</button>
                        <li><a href="/" className="nav-link">Launches</a></li>
                        <li><a href="/" className="nav-link">Sneakers</a></li>
                        <li><a href="/" className="nav-link">Appreal</a></li>
                        <li><a href="/" className="nav-link">Kids</a></li>
                        <li><a href="/" className="nav-link">Accessories</a></li>
                    </ul>
                    <div className="nav-right">
                        <a href="/" className="btn nav-link"><BiUser /></a>
                        <button data-count={cartTotal} onClick={() => toggleClass(setOpenCart, openCart)} className="btn nav-link cart-btn"><FaOpencart /></button>
                        <button onClick={() => toggleClass(setOpenNav, openNav)} className="transition-width-all close-nav">
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Navbar